import { Purchases as NativePurchases } from '@revenuecat/purchases-capacitor';
import { isNative } from './platform';

/**
 * Configure the RevenueCat SDK on native. apiKey is per app/store pair, so the
 * caller passes it. Web has no RevenueCat SDK: it buys through Stripe
 * Embedded Checkout via the app's own API, so this is a no-op there.
 */
export async function initializePurchases(apiKey: string): Promise<void> {
  if (!isNative()) return;
  await NativePurchases.configure({ apiKey });
}
